// OTHER-SPECIFY-1 (s155, D-155.6): the "Tell us more" box that reveals beneath a specifyOnOther
// select when its "Other"-type choice is selected. NON-REQUIRED — persists to generic_entries.specify_text
// via the standard entry write (the caller's onSave). Renders nothing unless the field is specifyOnOther
// AND the current value is an Other option, so a single mount is safe to drop after any select.
import { useState } from "react";
import { isOtherOption } from "@shared/constants/specify-on-other";

interface SpecifyOnOtherInputProps {
  /** field.specifyOnOther (from the section API / generic_fields.specify_on_other). */
  specifyOnOther?: boolean | null;
  /** the select's current value — the box shows only when this is an "Other" option. */
  value: string | null | undefined;
  /** current generic_entries.specify_text for this (field, row). */
  specifyText: string | null | undefined;
  /** persist the detail (the caller writes it to the same entry as specify_text). */
  onSave: (text: string) => void;
  readOnly?: boolean;
  testId?: string;
}

export function SpecifyOnOtherInput({ specifyOnOther, value, specifyText, onSave, readOnly, testId }: SpecifyOnOtherInputProps) {
  const [local, setLocal] = useState(specifyText ?? "");
  // Re-sync if the server value changes underneath (refetch), same pattern as the card fields.
  const [lastServer, setLastServer] = useState(specifyText ?? "");
  if ((specifyText ?? "") !== lastServer) {
    setLastServer(specifyText ?? "");
    setLocal(specifyText ?? "");
  }
  // Only when the field opted in AND an "Other" option is chosen. (When the select changes away from
  // Other, the server force-nulls specify_text; this just stops rendering the box.)
  if (!(specifyOnOther && isOtherOption(value))) return null;
  return (
    <input
      type="text"
      value={local}
      onChange={(e) => setLocal(e.target.value)}
      onBlur={() => { if (!readOnly && local !== (specifyText ?? "")) onSave(local); }}
      readOnly={readOnly}
      placeholder="Tell us more (optional)"
      aria-label="Other — tell us more (optional)"
      data-testid={testId ?? "specify-on-other-input"}
      className="mt-1.5 w-full rounded-md border border-warm-stone bg-warm-white px-2 py-1 text-sm text-[#2B2A26] placeholder:text-warm-taupe focus:outline-none focus:ring-1 focus:ring-sage-600/40"
    />
  );
}
